export default "__VITE_ASSET__Oj32j46W__"